export default "__VITE_ASSET__B3fAo77i__"